import { enums, integer, literal, optional, record, type } from "superstruct";

export const matchPredictionResponseStruct = type({
  status: literal("ok"),
  data: record(
    enums(["teamAway", "teamDraw", "teamHome"]),
    optional(integer()),
  ),
});
